<template lang="pug">
    .card
        .map-conaier(:class="{ show: showMap }")
            .title(v-if="hasTitleSlot")
                slot(name="title")
            MglMap(
                ref="mapbox"
                :accessToken="accessToken"
                :mapStyle="style"
                :center="calculatedCenter"
                :zoom="calculatedZoom"
                :max-zoom="18"
                :min-zoom="2.5"
                :interactive="false"
                @load="mapBoxLoaded"
            )
                MglMarker(
                    v-if="marker"
                    :coordinates="marker"
                    :color="color"
                    anchor="bottom"
                )
                    i.el-icon-fa-map-marker-alt.fas(slot="marker" :style="{ color }")
        .body
            slot
                p.small(v-if="address.company") {{ address.company }}
                p.small(v-if="address.name") {{ address.name }}
                p.small.gray(v-if="address.line_1 && ![address.company, address.name].includes(address.line_1)")
                    | {{ address.line_1 }}
                p.small.gray(v-if="address.line_2 && ![address.company, address.name].includes(address.line_2)")
                     | {{ address.line_2 }}
                p.small.gray(v-if="address.line_3 && ![address.company, address.name].includes(address.line_3)")
                    | {{ address.line_3 }}
                p.small.gray(v-if="address.line_4 && ![address.company, address.name].includes(address.line_4)")
                    | {{ address.line_4 }}
                p.small.gray(v-if="address.line_5 && ![address.company, address.name].includes(address.line_5)")
                    | {{ address.line_5 }}
                p.small(v-if="address.street") {{ address.street }}
                p.small(v-if="zipcodeAndCity") {{ zipcodeAndCity }}
                p.small(v-if="country") {{ country }}
</template>

<script>

import axios from 'axios'
import Mapbox from 'mapbox-gl'
import MultiTouch from 'mapbox-gl-multitouch'
import { MglMap, MglMarker } from 'vue-mapbox'
import { getTime, startOfDay } from 'date-fns'

import { country } from '@/filters'

export default {
    name: 'AddressCard',
    data() {
        return {
            accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
            style: 'mapbox://styles/vanameland/ckclxo9az13jn1io5gnwr9tjr',
            color: '#be1521',
            germany: [10.4515, 51.1657],
            center: [10.4515, 51.1657],
            zoom: 2.5,
            showMap: false,
        }
    },
    props: {
        address: {
            type: Object,
            required: true,
        }
    },
    components: {
        MglMap,
        MglMarker
    },
    computed: {
        // company() {
        //     return this.address.company
        // },
        // name() {
        //     return this.address.name
        // },
        // street() {
        //     return this.address.street
        // },
        // zipcode() {
        //     return this.address.zipcode
        // },
        // city() {
        //     return this.address.city
        // },
        zipcodeAndCity() {
            let result = ''
            if (this.address.zipcode) result += this.address.zipcode
            if (this.address.zipcode && this.address.city) result += ', '
            if (this.address.city) result += this.address.city
            return result
        },
        country() {
            const language = 'de'
            return country(this.address.country, language)
        },
        defaultBilling() {
            return this.address.default_billing
        },
        defaultShipping() {
            return this.address.default_shipping
        },
        marker() {
            let marker = undefined
            if (this.address.latitude && this.address.longitude) {
                marker = [this.address.longitude, this.address.latitude]
            }
            return marker
        },
        calculatedCenter: {
            get() {
                let center = this.center
                if (this.marker) center = this.marker
                return center
            },
            set(value) {
                this.center = value
            }
        },
        calculatedZoom: {
            get() {
                let zoom = this.zoom
                if (this.marker) zoom = 14
                return zoom
            },
            set(value) {
                this.zoom = value
            }
        },
        hasTitleSlot() {
            return !! this.$slots['title']
        },
    },
    methods: {
        findAddresses(query, cb) {
            const language = 'de'
            const timestamp = getTime(startOfDay(new Date()))
            const proximity = this.germany.join(',')

            let parts = []
            if (this.street && this.street.length >= 2) parts.push(this.street)
            if (this.zipcode && this.zipcode.length >= 2) parts.push(this.zipcode)
            if (this.city && this.city.length >= 2) parts.push(this.city)
            if (this.country) parts.push(this.country)
            // else parts.push(country('de', language))

            query = parts.join(' ')

            axios
            // &languageMode=strict
            // &types=postcode,address
                .get(`${process.env.VUE_APP_MAPBOX_GOECODING_ENDPOINT}${query}.json?access_token=${process.env.VUE_APP_MAPBOX_TOKEN}&cachebuster=${timestamp}&autocomplete=true&language=${language}&types=postcode,address&proximity=${proximity}`)
                .then(({ data }) => {
                    let suggestions = []
                    if (data && data.features && data.features.length) {
                        data.features.forEach(feature => {
                            if (feature.place_name
                                // && (feature.place_type.includes('address') || feature.place_type.includes('postcode'))
                                && (feature.place_type.includes('address') || feature.place_type.includes('postcode'))
                                && feature.relevance >= 0.5
                            ) {
                                suggestions.push({ value: feature.place_name, data: feature })
                            }
                        })
                    }

                    cb(suggestions)
                })
                // eslint-disable-next-line
                .catch(err => cb(null));
        },
        refreshMarker() {
            this.findAddresses('', items => {
                if (items && items.length) {
                    const match = items[0]
                    if (match.data.relevance > 0.9) this.setMarker(match)
                }
            })
        },
        fixMapCenter() {
            if (! this.marker) this.refreshMarker()
            else if (this.marker) this.zoom = 14
        },
        setMarker(address) {
            if (address.data && address.data.context && address.data.context.length) {
                if (address.data.id.startsWith('address')) {
                    this.$emit('set-marker', { longitude: address.data.center[0], latitude: address.data.center[1] })

                    // this.center = this.marker
                    // this.zoom = 14

                    // this.$refs.mapbox.map.flyTo({
                    //     center: this.marker,
                    //     essential: true,
                    //     zoom: 14,
                    // })
                }
            }
        },
        async mapBoxLoaded(event) {
            // const language = 'de'

            let map = event.map
            // map.setLayoutProperty('country-label', 'text-field', [ 'get', 'name_' + language ]);

            this.fixMapCenter()
            setTimeout(() => this.showMap = true, 300);

            map.addControl(new MultiTouch());
        }
    },
    created() {
        // We need to set mapbox-gl library here in order to use it in template

        this.mapbox = Mapbox;

        // const language = 'de'
        // this.$refs.mapbox.map.setLayoutProperty('country-label', 'text-field', [
        //     'get',
        //     'name_' + language
        // ])
    },
}
</script>

<style lang="sass" scoped>
$border-radius: 4px
.card
    border-radius: $border-radius
    border: 1px solid $--border-color-light
    width: 100%
    +res(lg)
        max-width: 420px
    .map-conaier
        background: $color-skeleton
        border-top-right-radius: $border-radius
        border-top-left-radius: $border-radius
        overflow: hidden
        position: relative
        .mgl-map-wrapper
            opacity: 0
            transition: opacity .3s ease
            width: 100%
            min-height: 145px
        &.show
            .mgl-map-wrapper
                opacity: 1
        .title
            position: absolute
            left: 0
            bottom: 0
            margin: 0
            width: 100%
            padding: 6px 12px
            background: rgba(255, 255, 255, .6)
            backdrop-filter: blur(2px)
            z-index: 1
            *
                margin: 0
                padding: 0
                font-size: .75em
        .mapboxgl-marker
            font-size: 2rem
            line-height: 2rem
            height: 2rem
            &:after
                content: ''
                position: absolute
                width: 10px
                height: 0px
                bottom: -2px
                left: calc(50% - 5px)
                box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.8)
    .body
        padding: 12px
        background: #fafafa
        border-top: 1px solid $--border-color-light
        p
            margin: 0
            margin-bottom: 6px
            &:last-of-type
                margin-bottom: 0
            &.small
                font-size: .9em
            // &.gray
            //     color: rgba(0, 0, 0, .4)
</style>
